function doExternalVideo() {
  class ExternalVideo extends HTMLElement {
    constructor() {
      super();
      this.ratioElement = this.querySelector(".forceRatio");
      this.init();

      if (this.dataset.screenSize == "mobile" && checkWindowSize("mediumUp")) {
        return undefined;
      }
      if (
        this.dataset.screenSize == "desktop" &&
        checkWindowSize("mediumDown")
      ) {
        return undefined;
      }
    }

    async init() {
      await this.getVimeoOEmbedData(this.dataset.vimeoid).then((data) => {
        console.log(this.dataset.screenSize, { data });
        this.forceRatio(data.height, data.width);
        this.querySelector(".iframeOutput").innerHTML = this.iframeHtml();
      });
    }

    /**
     * @param {Number} videoHeight
     * @param {Number} videoWidth
     */
    forceRatio(videoHeight, videoWidth) {
      const ratioInPercentage = (videoHeight / videoWidth) * 100;
      this.ratioElement.style.paddingTop = ratioInPercentage + "%";
    }

    async getVimeoOEmbedData(vimeoId) {
      const oEmbedEndpoint = "https://vimeo.com/api/oembed.json";
      const vimeoUrl = "https://vimeo.com/" + vimeoId;
      const url = `${oEmbedEndpoint}?url=${encodeURIComponent(vimeoUrl)}`;
      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        return data;
      } catch (error) {
        console.error("Failed to fetch oEmbed data:", error);
      }
    }

    iframeHtml() {
      return `<iframe
      frameborder="0"
      src="https://player.vimeo.com/video/${this.dataset.vimeoid}?badge=${
        this.dataset.badge
      }&amp;autopause=${this.dataset.autopause}&amp;autoplay=${
        this.dataset.autoplay
      }&amp;loop=${this.dataset.loop}&amp;muted=${
        this.dataset.muted
      }&amp;player_id=${this.dataset.playerId}&amp;background=${
        this.dataset.background
      }">
      ${this.dataset.autoplay == "1" ? 'allow="autoplay"' : ""}
      </iframe>`;
    }
  }

  customElements.define("external-video", ExternalVideo);
}
doExternalVideo();

function checkWindowSize(mediaQuerySize) {
  let windowWidth =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;

  if (mediaQuerySize === "mediumDown") {
    // the start of large is the end of medium
    if (windowWidth < window.mediaQuery.large - 1) return true;
  }

  if (mediaQuerySize === "mediumUp") {
    // mediumUp is the end of medium which is the start of large
    if (windowWidth > window.mediaQuery.large) return true;
  }
  return false;
}
